import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Text, Box, Anchor, Image } from 'wt-ui';
import API from '../../services/API';

const PdfLink = ({ data }) => {
  console.log('PdfLink', data);
  const [title, page] = JSON.parse(data);
  return (
    <Anchor
      primary
      weight="600"
      href={`https://www.wisdomtree.eu/en-gb/-/media/eu-media-files/other-documents/educational/wt_short_leveraged_rebrand_v2_final.pdf#page=${page}`}
      target="_blank"
    >
      {title}
    </Anchor>
  );
};
PdfLink.propTypes = {
  data: PropTypes.string.isRequired,
};

const WebLink = ({ data }) => {
  console.log('WebLink', data);
  const [title, link] = JSON.parse(data);
  return (
    <Anchor primary weight="600" href={decodeURIComponent(link)} target="_blank">
      {title}
    </Anchor>
  );
};
WebLink.propTypes = {
  data: PropTypes.string.isRequired,
};

const renderers = {
  // image or video
  image: (props) => {
    // eslint-disable-next-line react/prop-types
    const { src, alt } = props;
    if (alt === 'Video') {
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video width="100%" autoPlay={false} controls>
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    // render image
    // replace image url as per current app base url
    return (
      <Image src={src.replace('../public/', process.env.REACT_APP_BASE_URL)} alt={alt} style={{ maxWidth: '100%' }} />
    );
  },

  paragraph: (props) => <p {...props} style={{ marginTop: '14px', marginBottom: '14px' }} />,
};

const Message = (props) => {
  const { data } = props;
  console.log('data: ', data);
  let content = '';
  switch (data.type) {
    case 'user':
      content = (
        <Box
          background="transparent"
          pad="small"
          border={{ color: '#05a9b1', style: 'solid' }}
          style={{ maxWidth: '600px' }}
        >
          <Text color="#333">
            <b>Q:</b> {data.message}
          </Text>
        </Box>
      );
      break;
    case 'azure': {
      if (data.answer === 'No good match found in KB.' || data.error) {
        content = (
          <>
            <Box
              background="transparent"
              alignSelf="end"
              border={{ color: '#333', style: 'solid' }}
              style={{ maxWidth: '600px', color: '#333' }}
            >
              <Box background="transparent" direction="row" pad="small">
                <Box background="transparent" style={{ color: '#333', paddingRight: '15px' }}>
                  <p>
                    <b>A:</b>
                  </p>
                </Box>
                <Box background="transparent" style={{ color: '#333' }}>
                  <p color="#333">Sorry, but we couldn't find an answer for your question.</p>
                  <p color="#333">
                    Please try again or feel free to{' '}
                    <Anchor href={API.getContactUrl()} primary weight="600" target="_blank">
                      contact us
                    </Anchor>
                    .
                  </p>
                </Box>
              </Box>
            </Box>
          </>
        );
        break;
      }

      content = (
        <Box
          background="transparent"
          alignSelf="end"
          border={{ color: '#333', style: 'solid' }}
          style={{ color: '#333' }}
        >
          <Box background="transparent" direction="row" pad="small">
            <Box background="transparent" style={{ color: '#333', paddingRight: '25px' }}>
              <p>
                <b>A:</b>
              </p>
            </Box>
            <Box background="transparent" style={{ color: '#333' }}>
              <div>
                <ReactMarkdown source={data.answer} renderers={renderers} />
              </div>
            </Box>
          </Box>
        </Box>
      );
      break;
    }
    default:
      content = '';
  }

  return content;
};

Message.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default Message;
